var _excluded = ["children"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
function Animate(_ref) {
  var children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(motion.div, rest, children);
}
Animate.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   *
   */
  animate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  /**
   *
   */
  exit: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  /**
   * React component, HTML node, string
   */
  children: PropTypes.node.isRequired,
  /**
   *
   */
  initial: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  /**
   *
   */
  transition: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  /**
   *
   */
  variants: PropTypes.object
} : {};
Animate.defaultProps = {
  animate: 'in',
  exit: 'out',
  initial: 'initial',
  transition: {
    duration: 0.4
  },
  variants: {
    initial: {
      opacity: 0
    },
    in: {
      opacity: 1
    },
    out: {
      opacity: 0
    }
  }
};
export default Animate;